import React, { useEffect, useRef, useState, useMemo } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import { Grid } from '@mui/material';
import TextInput from '../Input/TextInput';
import { useTranslation } from 'react-i18next';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import { toast } from 'react-toastify';
import axios from 'axios';
import imgDefault from './upload.png';
import NumberInput from '../Input/NumberInput';
import ButtonAction from '../Button.js/SaveButton';
import ComboBox from '../Input/ComboBox';
import Loader from '../loader/loader';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};
const CabinetModal = ({ visible = false, dataUpdate, setVisible, fuctGet, idPermission, isEdit }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [flagAddStat, setFlagAddStat] = useState(false);
    const addCabinetFlag = React.useRef(false);
    const [blob, setBlob] = useState('');
    const [imgEdit, setImgEdit] = useState('');
    const [name, setName] = useState('');
    const [quantity, setQuantity] = useState('');
    const [valueOption, setValueOption] = useState(null);
    const optionCabinetType = useMemo(
        () => [
            {
                value: 'square',
                label: t('cabinet_square'),
            },
            {
                value: 'round',
                label: t('cabinet_round'),
            },
        ],
        [t]
    );

    const [code, setcode] = useState('');

    const imageName = useRef('');
    const dataReqImg = useRef({
        imgType: '',
        image_data: '',
        size: 0,
        encodeType: null,
    });

    const [isSubmit, setIsSubmit] = useState(false);

    useEffect(() => {
        imageName.current = dataUpdate?.img_cabinet;
        if (isEdit) {
            setBlob('');
            setImgEdit(dataUpdate?.img_cabinet);
            setName(dataUpdate.cabinet_nm);
            setQuantity(dataUpdate.drawer_no);
            setcode(dataUpdate.cabinet_cd);
            if (dataUpdate.cabinet_type === 'square') {
                setValueOption(optionCabinetType[0]);
            } else {
                setValueOption(optionCabinetType[1]);
            }
            dataReqImg.current = {
                imgType: '',
                image_data: '',
                size: 0,
                encodeType: null,
            };
        } else {
            setBlob('');
            setName('');
            setQuantity('');
            setcode('');
            dataReqImg.current = {
                imgType: '',
                image_data: '',
                size: 0,
                encodeType: null,
            };
        }
        setFileToUpload(null);
        setBlob('');
        setIsSubmit(false);
    }, [dataUpdate]);

    const [fileToUpload, setFileToUpload] = useState(null);

    const handleOnChangeFile = async (e) => {
        let file = e.target.files[0];
        if (!file) return;
        if (file.size > 50 * 1024 * 1024) {
            toast.error(t('error.file_too_large'));
            return;
        }
        setFileToUpload(file);
        try {
            const url = URL.createObjectURL(file);
            setBlob(url);
        } catch (err) {
            console.error('Error creating object URL:', err);
        }
    };

    const handleAddReport = async () => {
        if (addCabinetFlag.current) return;
        setIsSubmit(true);
        if (!name || !code || !quantity || !valueOption) return toast.error(t('error.param'));

        addCabinetFlag.current = true;
        setFlagAddStat(true);

        try {
            if (fileToUpload) {
                const reader = new FileReader();
                const imageData = await new Promise((resolve, reject) => {
                    reader.onload = (evt) =>
                        resolve(evt.target.result.toString().replace(/^data:image\/\w+;base64,/, ''));
                    reader.onerror = (err) => reject(err);
                    reader.readAsDataURL(fileToUpload);
                });

                const req = await axios.post(`${glb_sv.urlPostProductImage}`, {
                    imgType: fileToUpload.type.slice(6),
                    image_data: imageData,
                    size: fileToUpload.size,
                    encodeType: 'base64',
                });
                if (req?.data?.success) {
                    imageName.current = req.data.data.imageName;
                } else {
                    toast.error(t('error.upload'));
                    setFlagAddStat(false);
                    addCabinetFlag.current = false;
                    return;
                }

                if (!imageName.current || imageName.current === '') {
                    toast.error(t('error.upload'));
                    setFlagAddStat(false);
                    addCabinetFlag.current = false;
                    return;
                }
            }

            if (isEdit) {
                const InVal = [+idPermission, name, code, dataUpdate.id, imageName.current];
                sendRequest(serviceList.updateCabinet, InVal, actionResult, true, timeOutFunct, 40000);
            } else {
                const InVal = [+idPermission, name, code, +quantity, imageName.current, valueOption.value];
                sendRequest(serviceList.createCabinet, InVal, actionResult, true, timeOutFunct, 40000);
            }
        } catch (error) {
            console.error('Upload error:', error);
            toast.error(t('error.system_error'));
            setFlagAddStat(false);
            addCabinetFlag.current = false;
        }
    };
    const actionResult = (reqInfoMap, message) => {
        addCabinetFlag.current = false;
        setFlagAddStat(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            toast.success(message['proc_message']);
            fuctGet && fuctGet();

            setVisible(!visible);
            setIsSubmit(false);
        }
    };
    const timeOutFunct = (reqInfo) => {
        setFlagAddStat(false);
        addCabinetFlag.current = false;
        setVisible(!visible);
        setIsSubmit(false);
        toast.error(t('error.time_out'));
    };

    return (
        <BootstrapDialog
            fullScreen={fullScreen}
            open={visible}
            onClose={() => setVisible(!visible)}
            aria-labelledby="customized-dialog-title"
        >
            <Loader loading={flagAddStat} />
            <BootstrapDialogTitle id="customized-dialog-title" onClose={() => setVisible(!visible)}>
                {isEdit ? t('update_cabinet') : t('create_cabinet')}
            </BootstrapDialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                        <ComboBox
                            label={t('cabinet_type')}
                            valueSelect={valueOption}
                            valueEqual="value"
                            disabled={isEdit}
                            required
                            getValue={setValueOption}
                            selectOption={optionCabinetType}
                            error={!isEdit && !valueOption && isSubmit}
                            helperText={!isEdit && !valueOption && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={12} md={6} sm={6} style={{ width: '100%' }}>
                        <TextInput
                            label={t('code_cabinet')}
                            valueChange={code}
                            required
                            getValue={setcode}
                            error={!code && isSubmit}
                            helperText={!code && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <TextInput
                            label={t('name_cabinet')}
                            valueChange={name}
                            getValue={setName}
                            required
                            autoFocus
                            error={!name && isSubmit}
                            helperText={!name && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <NumberInput
                            label={t('quantity')}
                            valueChange={quantity}
                            disabled={isEdit}
                            required
                            getValue={setQuantity}
                            error={!isEdit && !quantity && isSubmit}
                            helperText={!isEdit && !quantity && isSubmit ? t('required_input') : ''}
                        />
                    </Grid>
                    <Grid item xl={12} md={12} sm={12} style={{ width: '100%' }}>
                        <input
                            type="file"
                            name="upload"
                            accept="image/png,image/jpg,image/jpeg"
                            onChange={handleOnChangeFile}
                            id="upload"
                            style={{ display: 'none' }}
                        />
                        <label htmlFor="upload" className={'upload-img-report col-form-label'}>
                            {isEdit && !blob && imageName.current ? (
                                <>
                                    <span>{t('image_cabinet')}</span>
                                    <img src={`${glb_sv.urlGetProductImage(imgEdit)}`} alt="" />
                                </>
                            ) : (
                                <>
                                    <span>{t('image_cabinet')}</span>
                                    <img src={blob ? blob : imgDefault} alt="" />
                                </>
                            )}
                        </label>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions style={{ padding: '12px 16px' }}>
                <ButtonAction
                    disabled={flagAddStat}
                    onClick={() => {
                        setVisible(!visible);
                        setValueOption(null);
                        setFileToUpload(null);
                        setBlob('');
                    }}
                    type={'cancel'}
                    title={t('cancel')}
                />
                <ButtonAction disabled={flagAddStat} onClick={handleAddReport} type={'save'} title={t('save')} />
            </DialogActions>
        </BootstrapDialog>
    );
};

export default CabinetModal;
